<template>
  <Multiselect
    :id="id"
    :ref="`multiselect-${id}`"
    v-model="value"
    class="dropdown-single"
    :class="[`is-position-${optionPosition}`]"
    :options="options"
    :showLabels="false"
    :trackBy="trackBy"
    :label="label"
    placeholder=""
    :tabindex="tabindex"
    :searchable="false"
    :allowEmpty="false"
    :closeOnSelect="closeOnSelect"
    @open="onOpen"
    @update:modelValue="onInput"
  >
    <template #placeholder>
      <div class="dropdown-single__label">
        <slot name="label">
          <icon
            data="@icon/more-vertical.svg"
            :width="size.width"
            :height="size.height"
            :fill="false"
            color="#7D92A7"
          />
        </slot>
      </div>
    </template>

    <template #option="props">
      <slot
        name="option"
        :option="props.option"
      >
        <icon
          v-if="props.option.icon"
          :data="props.option.icon"
          :fill="false"
          :color="props.option.iconOption.color ? props.option.iconOption.color: defaultIconOption.color"
          :width="props.option.iconOption.width ? props.option.iconOption.width: defaultIconOption.width"
          :height="props.option.iconOption.height ? props.option.iconOption.height: defaultIconOption.height"
        />
        {{ props.option.label }}
      </slot>
    </template>
  </Multiselect>
</template>

<script lang="ts">
import { Mixins, Prop } from "vue-property-decorator"
import Multiselect from "vue-multiselect"
import { AppendToBody } from "@/mixins"
import { Options } from "vue-class-component"

type IconSize = "sm" | "md"
type OptionPosition = "left" | "right"

@Options({
  name: "DropdownSingleLabel",
  components: {
    Multiselect,
  },
})
export default class extends Mixins(AppendToBody) {
  @Prop({ default: [] }) options
  @Prop() declare id: string
  @Prop() trackBy: string
  @Prop() label: string
  @Prop({ default: false }) closeOnSelect: boolean
  @Prop({ default: 0 }) tabindex: number
  @Prop({ default: false }) declare appendDropDownToBody: boolean
  @Prop({ default: "left" }) declare optionPosition: OptionPosition
  @Prop({ default: "sm" }) iconSize: IconSize
  value = ""
  defaultIconOption = {
    width: "1em",
    height: "1em",
    color: "#81889B",
  }
  repositionDropDown: () => void
  get size() {
    let width: number
    let height: number

    switch (this.iconSize) {
      case "sm":
        width = height = 16
        break
      case "md":
        width = height = 24
        break
      default:
        width = height = 16
    }

    return {
      width,
      height,
    }
  }

  onInput(value) {
    this.$emit("input", {
      value,
      id: this.id,
    })

    this.value = ""
  }

  onOpen() {
    this.repositionDropDown()
  }
}
</script>
